import { gql } from "@apollo/client";

export const GET_MEGA_MENU = gql`
  query getMegaMenu {
    category {
      children {
        custom_image
        id
        name
        url_key
        url_path
        children {
          custom_image
          id
          name
          url_key
          url_path
          children {
            custom_image
            id
            name
            url_key
            url_path
            children {
              custom_image
              id
              name
              url_key
              url_path
            }
          }
        }
      }
    }
  }
`;

export const GET_CATEGORIES = gql`
  query getCategories($ids: [String!]!) {
    categories(filters: { ids: { in: $ids } }) {
      total_count
      items {
        id
        name
        image1
        url_path
      }
    }
  }
`;

export default {
  getMegaMenuQuery: GET_MEGA_MENU,
  getCategoryQuery: GET_CATEGORIES,
};
